module.exports = __webpack_public_path__ + "img/transparent-warning-icon.6b575ea5.png";